import React from 'react';

interface LoadingProps {
  message?: string;
}

const Loading: React.FC<LoadingProps> = ({ message = 'Loading...' }) => {
  return (
    <div className="py-6 sm:py-12">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="p-4 sm:p-6 lg:p-8 text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto mb-4"></div>
          <p className="text-lg text-secondary-900">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default Loading;
